import { AffiliateContract } from '@/models/Affiliate';
import { getData, postData } from '@/utils/apiTools';

export const getAffiliateContract = async (): Promise<AffiliateContract> => getData('/v1/users/user/affiliate/contract/download');

export const signAffiliateContract = async (): Promise<void> => postData('/v1/users/user/affiliate/contract/sign', { contractSigned: true });
